import Instance from "../../../../Axios";

// New Actions for the app

const GetOrcamentosTotalValor =
  (parceirosId, dataInicio, dataFim) => async (dispatch) => {
    await Instance()
      .get(`/energias/dashboard/orcamentosTotalValor`, {
        params: { parceirosId, dataInicio, dataFim },
      })
      .then(({ data }) => {
        //   console.log(data);
        dispatch({
          type: "GET_ORCAMENTOS_TOTAL_VALOR",
          payload: data.yData,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

export default GetOrcamentosTotalValor;
